import { styled } from "@mui/material/styles";
import { Tabs } from "@mui/material";
import Tab from "@mui/material/Tab";

export const MenuBarTabsContainer = styled(Tabs)`
  align-items: center;
`;

export const TabItem = styled(Tab)`
  min-height: 0;
  min-width: 70px;
  padding: 0;
  font-weight: 400;
  font-size: 0.65rem;
  margin-bottom: 6px;
`;
